import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlumnoCheckboxComponent } from './alumno-checkbox.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [AlumnoCheckboxComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MatCheckboxModule,
    ReactiveFormsModule
  ],
  exports: [AlumnoCheckboxComponent]
})
export class AlumnoCheckboxModule { }
